import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Plant",
  "Alpha Plant Name",
  "Scrap Source",
  "Scrap Price",
  "Actions",
];

const PriceWatcherScrapperTable = ({
  data = [],
  agro = [],
  currentPage,
  itemsPerPage,
}) => {
  const navigate = useNavigate();

  function calculateDiscountedPrice(originalPrice, discount) {
    const discountedPrice = originalPrice * (1 - discount);
    return discountedPrice;
  }

  const goToView = (alphaPlantId) => {
    // navigate(`/buyers-price-watcher/view/${id}`);
    navigate(`/price-scrapper/view/${alphaPlantId}`);
  };

  const getImageUrl = (plantId) => {
    const agroItem = agro.find((item) => item.id === +plantId);
    return agroItem ? agroItem.image : null;
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>
                  {getImageUrl(item?.alphaPlantId) ? (
                    <img
                      src={getImageUrl(item?.alphaPlantId)}
                      alt="Plant"
                      width="30"
                    />
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>{item?.alphaPlantName || "N/A"}</td>
                <td>{item?.scrapSource || "N/A"}</td>
                <td>₹{item?.plantPrice || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.alphaPlantId)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PriceWatcherScrapperTable;
